import { createTheme } from '@mui/material/styles';
import { defaultTheme } from '../../theme/themes/default';

/**
 * Help content (drawer, Documentation Center) always renders with the light
 * theme, regardless of the app's active theme. The illustrations and topic
 * text are only designed/tested against light colors, so e.g. the dark theme
 * produced unreadable contrast.
 */
export const helpTheme = createTheme(defaultTheme);
